<template>
</template>
<script>
    import PreviewElement from "./PreviewElement";
    import ScreenElement from "../../components/pagesbuilder/elements/ScreenElement";

    export default {
        name: "PreviewScreenElement",
        mixins: [
            PreviewElement,
            ScreenElement
        ],
        methods:{
            addVideoListeners(videoWrapper, frame) {
                if (this.myData.videoMediaData.params && this.myData.videoMediaData.params.popup) {
                    this.toggleInteractionWithFrame(false);
                    const videoUrl = this.getPopupVideoUrl();
                    const popupFrame = frame.cloneNode(true);
                    const popupVideoWrapper = videoWrapper.cloneNode(true);

                    popupFrame.setAttribute("src", videoUrl);
                    popupVideoWrapper.innerHTML = "";
                    popupVideoWrapper.appendChild(popupFrame);

                    // documentation for fancybox: https://fancyapps.com/fancybox/#examples

                    videoWrapper.addEventListener('click', (e) => {

                        var w = window.innerWidth;
                        var modalWidth = Math.ceil(0.75 * w);
                        var modalHeight = Math.ceil(modalWidth * 0.5625);

                        e.stopPropagation();
                        $.fancybox({
                            width: modalWidth,
                            height: modalHeight,
                            autoSize: false,
                            autoDimensions: false,
                            titleShow: false,
                            type: 'html',
                            content: popupVideoWrapper.innerHTML,
                            wrapCSS: "video-popup",
                            padding: 0
                        });
                    });
                } else {
                    this.toggleInteractionWithFrame(true);
                }
            },

            getPopupVideoUrl () {
                if (this.myData.videoMediaData.video.type === "vimeo") {
                    return this.createVimeoUrl(this.myData.videoMediaData.video, this.myData.videoMediaData.params, true);
                } else if (this.myData.videoMediaData.video.type === "wistia") {
                    return this.createWistiaUrl(this.myData.videoMediaData.video, this.myData.videoMediaData.params, true);
                }

                return "";
            }
        }
    }
</script>
